module.exports = __webpack_public_path__ + "img/drag-and-drop.0e44a7ae.png";